import { createContext } from "react";
import type { AddressFormValues } from "./-types";

export interface AddressFormState {
  values: AddressFormValues;
  errors: Partial<Record<keyof AddressFormValues, string>>;
  touched: Partial<Record<keyof AddressFormValues, boolean>>;
  onChange: (changes: Partial<AddressFormValues>) => void;
  onBlur: (name: keyof AddressFormValues) => void;
  validate: (address: AddressFormValues) => boolean;
}

const AddressFormContext = createContext<AddressFormState | undefined>(
  undefined,
);

export { AddressFormContext };
